import { Loader2 } from 'lucide-react';

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center">
          <span className="text-2xl font-bold text-white">L</span>
        </div>
        <Loader2 size={24} className="animate-spin text-blue-600" />
        <p className="text-slate-600">{message}</p>
      </div>
    </div>
  );
}

export default LoadingScreen;
